var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { InformationCircleIcon } from 'hugeicons-react';
import { useState } from 'react';
import ReportDialog from './report-dialog';
import { getDataGridLocaleText } from '../../../../application/common/constants/get-data-grid-locale-text';
var Personnel = function () {
    var theme = useTheme();
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var _a = __read(useState(false), 2), openDialog = _a[0], setOpenDialog = _a[1];
    var handleOpenDialog = function () {
        setOpenDialog(true);
    };
    var handleCloseDialog = function () {
        setOpenDialog(false);
    };
    var PersonnelColumn = [
        {
            field: 'asset',
            headerName: 'Asset',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1.5 : 1.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'string'
        },
        {
            field: 'totalChat',
            headerName: 'Total Chats',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'string'
        },
        {
            field: 'lastchat',
            headerName: 'Last Chat',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'string',
            renderCell: function (params) {
                var _a = params.value, date = _a.date, time = _a.time;
                return (_jsxs(Box, { children: [_jsx(Typography, { children: date }), _jsx(Typography, { variant: 'caption', color: 'textSecondary', children: time })] }));
            }
        },
        {
            field: 'documents',
            headerName: 'Documents',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'string'
        },
        {
            field: 'workOrderReport',
            headerName: 'Work Order Reports',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'string'
        },
        {
            field: 'summary',
            headerName: 'Summary',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.5 : 0.5,
            width: isXs ? 100 : isMd ? 100 : isscreen600900 ? 100 : undefined,
            renderCell: function (params) {
                return (_jsx("div", { style: {
                        display: 'flex'
                    }, children: _jsx("div", { children: _jsx(Button, { variant: 'outlined', color: 'primary', size: 'small', onClick: handleOpenDialog, children: "Generate" }) }) }));
            }
        },
        {
            field: 'action',
            headerName: '',
            renderCell: function (params) {
                return (_jsx("div", { style: {
                        display: 'flex',
                        alignContent: 'center',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }, children: _jsx("div", { children: _jsx(IconButton, { color: 'primary', size: 'small', children: _jsx(InformationCircleIcon, { size: 20 }) }) }) }));
            }
        }
    ];
    return (_jsxs(Box, { mt: 1, children: [_jsx(Box, { padding: '16px', minHeight: 400, width: '100%', sx: {
                    p: { xs: 0.5, md: 2 },
                    backgroundColor: 'white',
                    borderRadius: '16px',
                    boxShadow: '0 24px 48px 0 #919EAB29'
                }, children: _jsx(DataGrid, { localeText: getDataGridLocaleText(), getRowHeight: function () { return 'auto'; }, disableColumnSelector: true, disableRowSelectionOnClick: true, disableColumnResize: true, slotProps: {
                        filterPanel: {
                            filterFormProps: {
                                operatorInputProps: {
                                    variant: 'standard'
                                },
                                columnInputProps: {
                                    variant: 'standard'
                                },
                                valueInputProps: {
                                    InputComponentProps: {
                                        variant: 'standard'
                                    }
                                }
                            }
                        }
                    }, sx: {
                        overflow: 'auto',
                        borderWidth: '0px',
                        backgroundColor: 'transparent',
                        outline: 'none',
                        '& .MuiDataGrid-row': {
                            cursor: 'pointer',
                            paddingTop: '8px',
                            paddingBottom: '8px'
                        },
                        '&, [class^=MuiDataGrid]': { border: 'none' },
                        minHeight: __assign(__assign({ xs: 'calc(64vh - 25px) !important', sm: '400px' }, (isscreen600900 && { sm: '600px' })), (iscreen9001200 && { sm: '600px' })),
                        '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitleContainer': {
                            backgroundColor: '#F4F6F8 !important',
                            border: 'none'
                        },
                        '& .MuiDataGrid-selectedRowCount': {
                            display: 'none'
                        }
                    }, rows: [
                        {
                            id: 1,
                            asset: 'Dahuau NVR',
                            totalChat: '13',
                            lastchat: { date: '2023-05-02', time: '11:00 AM' },
                            documents: '12',
                            workOrderReport: '13'
                        }
                    ], columns: PersonnelColumn }) }), _jsx(ReportDialog, { open: openDialog, onClose: handleCloseDialog })] }));
};
export default Personnel;
